<template>
  <div class="discount-container" v-loading.fullscreen.lock="fullscreenLoading">
    <div>
      <span class="label">买手店：</span><span class="value">{{routeQuery.name}}</span>
      <span class="label">类目分类：</span><span class="value">{{routeQuery.categoryType==1?'Adult':'Kids'}}</span>
      <span class="label">季节：</span><span class="value">{{routeQuery.season}}{{routeQuery.co == '0' ? '' : '(CO)'}}</span>
      <template v-if="page === 'daily'">
        <span class="label">状态：</span><span class="value">{{routeQuery.status==1?'待生效':'生效中'}}<span v-if="hasPending"> (<span class="red">有待生效折扣</span>)</span></span>
      </template>
      <template v-if="supplyPriceMethod ">
        <span class="label">价格接入方式：</span><span class="value">{{supplyPriceMethod === '0' ? "Discount" : supplyPriceMethod === '2' ? "Cost" : ""}}</span>
      </template>
    </div>
    <div class="mt15" style="height: 32px;flex-shrink: 0;">
      <template v-if="(changedTable1 || changedTable2 || changedTable4 || changedTable3) && routeQuery.status!='5' && (page === 'daily' && submitBtnDaily || page === 'promotion' && submitBtnPromotion)">
        <span class="f14 red">当前折扣设置有变动，请全部修改完成后提交</span>
        <el-button type="primary" size="small" class="ml20" @click="submitPage">提交</el-button>
        <el-button type="primary" size="small" @click="reset">放弃全部修改</el-button>
      </template>
    </div>
    <el-alert class="mt15 mb10" style="flex-shrink: 0;" title="注：折扣均以off形式显示" type="warning"></el-alert>

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="二级类目" name="first"></el-tab-pane>
      <el-tab-pane label="三级类目" name="second"></el-tab-pane>
      <el-tab-pane label="四级类目" name="fourth"></el-tab-pane>
      <el-tab-pane label="特殊商品" name="third"></el-tab-pane>
    </el-tabs>
    <div class="toolbar">
      <p class="f14 gray" v-if='activeName=="first"'>共 {{tableData1.length}} 条</p>
      <p class="f14 gray" v-if='activeName=="second"'>共 {{tableData2.length}} 条</p>
      <p class="f14 gray" v-if='activeName=="fourth"'>共 {{tableData4.length}} 条</p>
      <p class="f14 gray" v-if='activeName=="third"'>共 {{tableData3.length}} 条</p>
      <el-button type="primary" size="small" plain @click="onClickAdd">添加</el-button>
    </div>

    <div class="table-container" v-loading="loading">
      <VirtualScrollTable ref="VirtualScrollTable1" v-if='activeName=="first"' key="firstTable" :rowHeight="48" :resetTop="false" height="100%" :data="tableData1">
        <el-table-column prop="brandId" label="品牌" class-name="nopadding">
          <template slot-scope="scope">
            <template v-if="scope.row.brandId.value == 0">Default</template>
            <template v-else>
              <div class="item-cell" :class="{error: scope.row.brandId.error, 'changed': scope.row.brandId.value != scope.row.brandId.oldValue}"
                v-if="!scope.row.brandId.isEdit"
                @click="onClickCell1(scope, 'brandId', $event)"
              >{{ brandMap[scope.row.brandId.value] }}&nbsp;</div>
              <BrandSelect
                v-else
                :data="brandList"
                v-model="scope.row.brandId.value"
                :disabledIds="getDisabledBrandIds1(scope.row.brandId.value)"
                @change="checkTableData1"
                filterable
              ></BrandSelect>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in header" :key="index" :label="item.label" align="right" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row[item.value].error, 'changed': scope.row[item.value].value.discount != scope.row[item.value].oldValue.discount || scope.row[item.value].value.discountType != scope.row[item.value].oldValue.discountType}"
              v-if="!scope.row[item.value].isEdit"
              @click="onClickCell1(scope, item.value, $event)"
            ><span v-if="supplyPriceMethod === '2'">{{ scope.row[item.value].value.discountType === "0" ? "R-" : ""}}&nbsp;</span>{{ scope.row[item.value].value.discount }}&nbsp;</div>
            <div v-else style="display: flex">
            <el-select @change="checkTableData1" v-model="scope.row[item.value].value.discountType" clearable style="width: 110px" v-if="supplyPriceMethod === '2'" >
              <el-option label="R-" value="0" key="R-"></el-option>
            </el-select>
            <el-input
              :ref="'input-' + scope.row.originIndex + '-' + item.value"
              v-model="scope.row[item.value].value.discount"
              @input="(val) => inputNum(val, scope.row[item.value])"
              @change="checkTableData1"
              @click.native.stop=""
            ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="50">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.error"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.errorMessage">
              <i slot="reference" class="el-icon-warning red"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="40">
          <template slot-scope="scope">
            <i v-if="scope.row.brandId.value != 0" class="el-icon-remove-outline" @click="onClickRemove1(scope)"></i>
          </template>
        </el-table-column>
      </VirtualScrollTable>

      <VirtualScrollTable ref="VirtualScrollTable2" v-if='activeName=="second"' key="secondTable" :rowHeight="48" :resetTop="false" height="100%" :data="tableData2">
        <el-table-column prop="brandId" label="品牌" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.brandId.error, 'changed': scope.row.brandId.value != scope.row.brandId.oldValue}"
              v-if="!scope.row.brandId.isEdit"
              @click="onClickCell2(scope, 'brandId', $event)"
            >{{ brandMap[scope.row.brandId.value] }}&nbsp;</div>
            <BrandSelect
              v-else
              :data="brandListWithDefault"
              v-model="scope.row.brandId.value"
              @change="checkTableData2"
              filterable
            ></BrandSelect>
          </template>
        </el-table-column>
        <el-table-column prop="categoryId" label="类目" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.categoryId.error, 'changed': scope.row.categoryId.value != scope.row.categoryId.oldValue}"
              v-if="!scope.row.categoryId.isEdit"
              @click="onClickCell2(scope, 'categoryId', $event)"
            >{{ categoryMap[scope.row.categoryId.value] }}&nbsp;</div>
            <el-cascader
              v-else
              v-model="scope.row.categoryId.value"
              @change="checkTableData2"
              :options="categoryList"
              :props="optionProps"
              @click.native.stop=""
              :style="{width: '100%'}"
            ></el-cascader>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣" class-name="nopadding" align="right">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.discount.error, 'changed': scope.row.discount.value.discount != scope.row.discount.oldValue.discount || scope.row.discount.value.discountType != scope.row.discount.oldValue.discountType}"
              v-if="!scope.row.discount.isEdit"
              @click="onClickCell2(scope, 'discount', $event)"
            ><span v-if="supplyPriceMethod === '2'">{{ scope.row.discount.value.discountType === "0" ? "R-" : ""}}&nbsp;</span>{{ scope.row.discount.value.discount }}&nbsp;</div>
            <div v-else style="display: flex">
            <el-select  @change="checkTableData2" v-model="scope.row.discount.value.discountType" clearable style="width: 110px" v-if="supplyPriceMethod === '2'">
              <el-option label="R-" value="0" key="R-"></el-option>
            </el-select>
            <el-input
              :ref="'input-' + scope.row.originIndex + '-discount'"
              v-model="scope.row.discount.value.discount"
              @input="(val) => inputNum(val, scope.row.discount)"
              @change="checkTableData2"
              @click.native.stop=""
            ></el-input>
          </div>
          </template>
        </el-table-column>
        <el-table-column prop="empty" label="" class-name="nopadding"></el-table-column>
        <el-table-column prop="error" width="50">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.error"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.errorMessage">
              <i slot="reference" class="el-icon-warning red"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="40">
          <template slot-scope="scope">
            <i class="el-icon-remove-outline" @click="onClickRemove2(scope)"></i>
          </template>
        </el-table-column>
      </VirtualScrollTable>
      <VirtualScrollTable ref="VirtualScrollTable4" v-if='activeName=="fourth"' key="fourthTable" :rowHeight="48" :resetTop="false" height="100%" :data="tableData4">
        <el-table-column prop="brandId" label="品牌" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.brandId.error, 'changed': scope.row.brandId.value != scope.row.brandId.oldValue}"
              v-if="!scope.row.brandId.isEdit"
              @click="onClickCell4(scope, 'brandId', $event)"
            >{{ brandMap[scope.row.brandId.value] }}&nbsp;</div>
            <BrandSelect
              v-else
              :data="brandListWithDefault"
              v-model="scope.row.brandId.value"
              @change="checkTableData4"
              filterable
            ></BrandSelect>
          </template>
        </el-table-column>
        <el-table-column prop="categoryId" label="类目" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.categoryId.error, 'changed': scope.row.categoryId.value != scope.row.categoryId.oldValue}"
              v-if="!scope.row.categoryId.isEdit"
              @click="onClickCell4(scope, 'categoryId', $event)"
            >{{ categoryFourMap[scope.row.categoryId.value] }}&nbsp;</div>
            <el-cascader
              v-else
              v-model="scope.row.categoryId.value"
              @change="checkTableData4"
              :options="categoryFourList"
              :props="optionProps"
              @click.native.stop=""
              :style="{width: '100%'}"
            ></el-cascader>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣" class-name="nopadding" align="right">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.discount.error, 'changed': scope.row.discount.value.discount != scope.row.discount.oldValue.discount || scope.row.discount.value.discountType != scope.row.discount.oldValue.discountType}"
              v-if="!scope.row.discount.isEdit"
              @click="onClickCell4(scope, 'discount', $event)"
            ><span v-if="supplyPriceMethod === '2'">{{ scope.row.discount.value.discountType === "0" ? "R-" : ""}}&nbsp;</span>{{ scope.row.discount.value.discount }}&nbsp;</div>
            <div v-else style="display: flex">
            <el-select  @change="checkTableData4" v-model="scope.row.discount.value.discountType" clearable style="width: 110px" v-if="supplyPriceMethod === '2'">
              <el-option label="R-" value="0" key="R-"></el-option>
            </el-select>
            <el-input
              :ref="'input-' + scope.row.originIndex + '-discount'"
              v-model="scope.row.discount.value.discount"
              @input="(val) => inputNum(val, scope.row.discount)"
              @change="checkTableData4"
              @click.native.stop=""
            ></el-input>
          </div>
          </template>
        </el-table-column>
        <el-table-column prop="empty" label="" class-name="nopadding"></el-table-column>
        <el-table-column prop="error" width="50">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.error"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.errorMessage">
              <i slot="reference" class="el-icon-warning red"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="40">
          <template slot-scope="scope">
            <i class="el-icon-remove-outline" @click="onClickRemove2(scope)"></i>
          </template>
        </el-table-column>
      </VirtualScrollTable>

      <VirtualScrollTable ref="VirtualScrollTable3" v-if='activeName=="third"' key="thirdTable" :rowHeight="48" :resetTop="false" height="100%" :data="tableData3">
        <el-table-column prop="designerId" label="商品货号" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.designerId.error, 'changed': scope.row.designerId.value != scope.row.designerId.oldValue}"
              v-if="!scope.row.designerId.isEdit"
              @click="onClickCell3(scope, 'designerId', $event)"
            >{{ scope.row.designerId.value }}&nbsp;</div>
            <el-input
              v-else
              :ref="'input-' + scope.row.originIndex + '-designerId'"
              v-model="scope.row.designerId.value"
              @change="onChangeDesignId(scope.row.designerId.value, scope.row.designerId)"
              @click.native.stop=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="colorCode" label="颜色编码" class-name="nopadding">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.colorCode.error, 'changed': scope.row.colorCode.value != scope.row.colorCode.oldValue}"
              v-if="!scope.row.colorCode.isEdit"
              @click="onClickCell3(scope, 'colorCode', $event)"
            >{{ scope.row.colorCode.value }}&nbsp;</div>
            <el-input
              v-else
              :ref="'input-' + scope.row.originIndex + '-colorCode'"
              v-model="scope.row.colorCode.value"
              @change="onChangeColorCode(scope.row.colorCode.value, scope.row.colorCode)"
              @click.native.stop=""
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣" class-name="nopadding" align="right">
          <template slot-scope="scope">
            <div class="item-cell" :class="{error: scope.row.discount.error, 'changed': scope.row.discount.value.discount != scope.row.discount.oldValue.discount || scope.row.discount.value.discountType != scope.row.discount.oldValue.discountType}"
              v-if="!scope.row.discount.isEdit"
              @click="onClickCell3(scope, 'discount', $event)"
            ><span v-if="supplyPriceMethod === '2'">{{ scope.row.discount.value.discountType === "0" ? "R-" : ""}}&nbsp;</span>{{ scope.row.discount.value.discount }}&nbsp;</div>
            <div v-else style="display: flex">
            <el-select  @change="checkTableData3" v-model="scope.row.discount.value.discountType" clearable style="width: 110px" v-if="supplyPriceMethod === '2'">
              <el-option label="R-" value="0" key="R-"></el-option>
            </el-select>
            <el-input
              :ref="'input-' + scope.row.originIndex + '-discount'"
              v-model="scope.row.discount.value.discount"
              @input="(val) => inputNum(val, scope.row.discount)"
              @change="checkTableData3"
              @click.native.stop=""
            ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="empty" label="" class-name="nopadding"></el-table-column>
        <el-table-column prop="error" width="50">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.error"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.errorMessage">
              <i slot="reference" class="el-icon-warning red"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="error" width="40">
          <template slot-scope="scope">
            <i class="el-icon-remove-outline" @click="onClickRemove3(scope)"></i>
          </template>
        </el-table-column>
      </VirtualScrollTable>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  category,
  getAllCategory2,
  getAllCategory3,
  getAllCategory4,
  getBoutiqueProductRate,
  getPromotionVendorDiscountCategory2List,
  getPromotionVendorDiscountCategory3List,
  getPromotionVendorDiscountSpecialProductList,
  submitBoutiqueProductDiscount,
  submitPromotionVendorDiscountDetail,
  checkPriceChangeRule,
  getFourCategoryList
} from '../api.js'
import {
  getBrandList,
} from '../../../seller/api_cn.js';
import VirtualScrollTable from '../../../shared/VirtualScrollTableNew.vue';
import BrandSelect from '../../../shared/brandSelect.vue';

export default {
  components: {
    VirtualScrollTable,
    BrandSelect,
  },
  data() {
    return {
      page: this.$route.query.page,
      routeQuery: this.$route.query,
      supplyPriceMethod: this.$route.query.supplyPriceMethod,
      fullscreenLoading: false,
      currentPage: 1,
      pageSize: 15,
      loading: false,
      tableData1: [],
      tableData2: [],
      tableData4: [],
      tableData3: [],
      header: [],
      activeName: 'first',
      brandList: [],
      brandMap: {},
      categoryList: [],
      categoryFourList: [],
      categoryMap: {},
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: false,
        label: 'chineseName',
        value: 'categoryId',
      },
      hasPending: false, // 是否有待生效折扣
      tableData1Loaded: false,
      tableData2Loaded: false,
      tableData3Loaded: false,
      tableData4Loaded: false,
    };
  },
  computed: {
    ...mapState({
      submitBtnDaily: (state) => state.app.menuMap['折扣管理-daily-discount-提交'],
      submitBtnPromotion: (state) => state.app.menuMap['折扣管理-活动折扣-提交'],
    }),
    changedTable1() {
      return (
        this.tableData1Loaded &&
        (this.tableData1.length !== this.tableData1Total ||
        this.tableData1.some(row => {
          return row.brandId.value != row.brandId.oldValue || this.header.some(headerItem => {
            return row[headerItem.value].value.discount != row[headerItem.value].oldValue.discount || row[headerItem.value].value.discountType != row[headerItem.value].oldValue.discountType;
          });
        }))
      )
    },
    changedTable2() {
      return (
        this.tableData2Loaded &&
        (
          this.tableData2.length !== this.tableData2Total ||
          this.tableData2.some(row => {
            return row.brandId.value != row.brandId.oldValue || row.categoryId.value != row.categoryId.oldValue || row.discount.value.discount != row.discount.oldValue.discount || row.discount.value.discountType != row.discount.oldValue.discountType;
          })
        )
      );
    },
    changedTable4() {
      return (
        this.tableData4Loaded &&
        (
          this.tableData4.length !== this.tableData4Total ||
          this.tableData4.some(row => {
            return row.brandId.value != row.brandId.oldValue || row.categoryId.value != row.categoryId.oldValue || row.discount.value.discount != row.discount.oldValue.discount || row.discount.value.discountType != row.discount.oldValue.discountType;
          })
        )
      );
    },
    changedTable3() {
      return (
        this.tableData3Loaded &&
        (
          this.tableData3.length !== this.tableData3Total ||
          this.tableData3.some(row => {
            return row.designerId.value != row.designerId.oldValue || row.colorCode.value != row.colorCode.oldValue || row.discount.value.discount != row.discount.oldValue.discount|| row.discount.value.discountType != row.discount.oldValue.discountType;
          })
        )
      );
    },
    brandListWithDefault() {
      return [{
        label: 'Default',
        value: 0,
      }, ...this.brandList];
    },
  },
  created() {
    this.supplyPriceMethod = this.$route.query.supplyPriceMethod;
    this.getCategoryList();
    this.getFourCategoryList();
    getBrandList().then((res) => {
      this.brandList = (res.data || []).map(item => {
        return {
          label: item.englishName,
          value: item.brandId,
        };
      });
      this.brandMap = res.data.reduce((acc, cur) => {
        acc[cur.brandId] = cur.englishName;
        return acc;
      }, {
        0: 'Default',
      });
    });
    if (this.page === 'daily') {
      checkPriceChangeRule(this.routeQuery.id).then(res => {
        if (res.data) {
          this.hasPending = res.data.hasPending;
          if (res.data.runStatus == 2) {
            this.$message('当前折扣计算中无法提交，请稍后处理');
          }
        }
      })
    }
  },
  mounted() {
    window.addEventListener("click", this.onClickPage);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.onClickPage);
  },
  methods: {
    async getCategoryList() {
      const res = (await category()).data;
      const map = {};
      const categoryList = (res || []).map((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            if (item2.children && item2.children.length > 0) {
              item2.children.forEach((item3) => {
                map[item3.categoryId] = `${item.chineseName}>${item2.chineseName}>${item3.chineseName}`;
              });
            } else {
              item2.children = null;
            }
          });
        } else {
          item.children = null;
        }
        return item;
      });
      this.categoryMap = map;
      const temp = categoryList.filter(item => {
        return this.routeQuery.categoryType == 1 ? ![1757, 1758, 1759].includes(item.categoryId) : [1757, 1758, 1759].includes(item.categoryId);
      })
      this.categoryList = temp;
      const arr = []
      for (let index = 0; index < temp.length; index++) {
        const el = temp[index];
        for (let j = 0; j < el.children.length; j++) {
          const element = el.children[j];
          arr.push({ label: el.chineseName + '-' + element.chineseName, value: element.categoryId });
        }
      }
      this.header = arr;
      this.getTableData();
    },
    async getFourCategoryList() {
      const res = (await getFourCategoryList()).data;
      const map = {};
      const categoryList = (res.data || []).map((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            if (item2.children && item2.children.length > 0) {
              item2.children.forEach((item3) => {
                if (item3.children && item3.children.length > 0) {
                  item3.children.forEach((item4) => {
                    map[item4.categoryId] = `${item.chineseName}>${item2.chineseName}>${item3.chineseName}>${item4.chineseName}`;
                  });
                } else {
                  item3.children = null;
                }
              });
            } else {
              item2.children = null;
            }
          });
        } else {
          item.children = null;
        }
        return item;
      });
      this.categoryFourMap = map;
      console.log('categoryFourMap',this.categoryFourMap)
      const temp = categoryList.filter(item => {
        return this.routeQuery.categoryType == 1 ? ![1757, 1758, 1759].includes(item.categoryId) : [1757, 1758, 1759].includes(item.categoryId);
      })
      this.categoryFourList = temp;
      // const arr = []
      // for (let index = 0; index < temp.length; index++) {
      //   const el = temp[index];
      //   for (let j = 0; j < el.children.length; j++) {
      //     const element = el.children[j];
      //     arr.push({ label: el.chineseName + '-' + element.chineseName, value: element.categoryId });
      //   }
      // }
      // this.header = arr;
      // this.getTableData();
    },
    handleClick(tab, event) {
    },
    async reset() {
      const result = await this.$confirm('确认放弃当前所有修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      if (!result) { return }
      this.onClickPage();
      this.getTableData();
    },
    async getTableData() {
      this.getTableData1();
      this.getTableData2();
      this.getTableData4();
      this.getTableData3();
    },
    async getTableData1() {
      this.loading = true;
      const id = this.routeQuery.id;
      let request = getAllCategory2;
      if (this.page === 'promotion') {
        request = getPromotionVendorDiscountCategory2List;
      }
      this.autoIncrement1 = 0;
      const resData = (await request(id)).data;
      this.tableData1 = resData.map(item => {
        const row = {
          error: false, // 行错误标识
          errorMessage: '', // 行错误消息
          originIndex: this.autoIncrement1++,
        };
        row.brandId = {
          isEdit: false,
          value: item.brandId,
          error: false, // 错误
          oldValue: item.brandId, // 旧值
        };
        this.header.forEach((headerItem) => {
          row[headerItem.value] = {
            isEdit: false,
            value: {
              discount: item[headerItem.value] && item[headerItem.value].discount,
              discountType: item[headerItem.value] && item[headerItem.value].discountType === 0 ? "0" : "",
            },
            error: false,
            oldValue:{
              discount: item[headerItem.value] && item[headerItem.value].discount,
              discountType: item[headerItem.value] && item[headerItem.value].discountType === 0 ? "0" : "",
            }, // 旧值
          };
        });
        return row;
      });
      this.tableData1Total = this.tableData1.length;
      this.tableData1Loaded = true;
      this.loading = false;
    },
    async getTableData2() {
      const id = this.routeQuery.id;
      let request = getAllCategory3;
      if (this.page === 'promotion') {
        request = getPromotionVendorDiscountCategory3List;
      }
      this.autoIncrement2 = 0;
      const resData = (await request(id)).data;
      this.tableData2 = resData.map(item => {
        const row = {
          error: false,
          errorMessage: '',
          originIndex: this.autoIncrement2++,

          brandId: {
            isEdit: false,
            value: item.brandId,
            error: false, // 错误
            oldValue: item.brandId, // 旧值
          },
          categoryId: {
            isEdit: false,
            value: item.categoryId,
            error: false, // 错误
            oldValue: item.categoryId, // 旧值
          },
          discount: {
            isEdit: false,
            value: {
              discount: item.discount,
              discountType: item.discountType === 0 ? "0" : "",
            },
            error: false, // 错误
            oldValue: {
              discount: item.discount,
              discountType: item.discountType === 0 ? "0" : "",
            },
          },
        };
        return row;
      });
      this.tableData2Total = this.tableData2.length;
      this.tableData2Loaded = true;
    },
    async getTableData4() {
      const id = this.routeQuery.id;
      let request = getAllCategory4;
      if (this.page === 'promotion') {
        return;
      }
      this.autoIncrement4 = 0;
      const resData = (await request(id)).data;
      this.tableData4 = resData.map(item => {
        const row = {
          error: false,
          errorMessage: '',
          originIndex: this.autoIncrement4++,

          brandId: {
            isEdit: false,
            value: item.brandId,
            error: false, // 错误
            oldValue: item.brandId, // 旧值
          },
          categoryId: {
            isEdit: false,
            value: item.categoryId,
            error: false, // 错误
            oldValue: item.categoryId, // 旧值
          },
          discount: {
            isEdit: false,
            value: {
              discount: item.discount,
              discountType: item.discountType === 0 ? "0" : "",
            },
            error: false, // 错误
            oldValue: {
              discount: item.discount,
              discountType: item.discountType === 0 ? "0" : "",
            },
          },
        };
        return row;
      });
      this.tableData4Total = this.tableData4.length;
      this.tableData4Loaded = true;
    },
    async getTableData3() {
      const id = this.routeQuery.id;
      let request = getBoutiqueProductRate;
      if (this.page === 'promotion') {
        request = getPromotionVendorDiscountSpecialProductList;
      }
      this.autoIncrement3 = 0;
      const resData = (await request(id)).data;
      this.tableData3 = resData.map(item => {
        const row = {
          error: false,
          errorMessage: '',
          originIndex: this.autoIncrement3++,

          designerId: {
            isEdit: false,
            value: item.designerId,
            error: false, // 错误
            oldValue: item.designerId, // 旧值
          },
          colorCode: {
            isEdit: false,
            value: item.colorCode,
            error: false, // 错误
            oldValue: item.colorCode, // 旧值
          },
          discount: {
            isEdit: false,
            value: {
              discount: item.discount,
              discountType: item.discountType === 0 ? "0" : "",
            },
            error: false, // 错误
            oldValue: {
              discount: item.discount,
              discountType: item.discountType === 0 ? "0" : "",
            },
          },
        };
        return row;
      });
      this.tableData3Total = this.tableData3.length;
      this.tableData3Loaded = true;
    },
    onClickPage() {
      this.tableData1.forEach((row) => {
        row.brandId.isEdit = false;
        this.header.forEach((headerItem) => {
          row[headerItem.value].isEdit = false;
        });
      });
      this.tableData2.forEach((row) => {
        row.brandId.isEdit = false;
        row.categoryId.isEdit = false;
        row.discount.isEdit = false;
      });
      this.tableData4.forEach((row) => {
        row.brandId.isEdit = false;
        row.categoryId.isEdit = false;
        row.discount.isEdit = false;
      });
      this.tableData3.forEach((row) => {
        row.designerId.isEdit = false;
        row.colorCode.isEdit = false;
        row.discount.isEdit = false;
      });
    },
    onClickCell1(scope, key, event) {
      event.stopPropagation();
      this.tableData1.forEach((row) => {
        if (key === 'brandId') {
          if (scope.row.originIndex === row.originIndex) {
            row.brandId.isEdit = true;
          } else {
            row.brandId.isEdit = false;
          }
        } else {
          this.header.forEach((headerItem) => {
            // TODO 留意虚拟表格滚动的影响
            if (scope.row.originIndex === row.originIndex && key == headerItem.value) {
              row[headerItem.value].isEdit = true;
            } else {
              row[headerItem.value].isEdit = false;
            }
          });
        }
      });
      this.$nextTick(() => {
        if (key !== 'brandId') {
          this.$refs[`input-${scope.row.originIndex}-${key}`][0].select();
        }
      })
    },
    onClickCell2(scope, key, event) {
      event.stopPropagation();
      this.tableData2.forEach((row) => {
        // TODO 留意虚拟表格滚动的影响
        if (scope.row.originIndex === row.originIndex) {
          row[key].isEdit = true;
        } else {
          row[key].isEdit = false;
        }
      });
      this.$nextTick(() => {
        if (key === 'discount') {
          this.$refs[`input-${scope.row.originIndex}-${key}`].select();
        }
      })
    },
    onClickCell4(scope, key, event) {
      event.stopPropagation();
      this.tableData4.forEach((row) => {
        // TODO 留意虚拟表格滚动的影响
        if (scope.row.originIndex === row.originIndex) {
          row[key].isEdit = true;
        } else {
          row[key].isEdit = false;
        }
      });
      this.$nextTick(() => {
        if (key === 'discount') {
          this.$refs[`input-${scope.row.originIndex}-${key}`].select();
        }
      })
    },
    onClickCell3(scope, key, event) {
      event.stopPropagation();
      this.tableData3.forEach((row) => {
        // TODO 留意虚拟表格滚动的影响
        if (scope.row.originIndex === row.originIndex) {
          row[key].isEdit = true;
        } else {
          row[key].isEdit = false;
        }
      });
      this.$nextTick(() => {
        this.$refs[`input-${scope.row.originIndex}-${key}`].select();
      })
    },
    inputNum(val, cell) {
      if (this.supplyPriceMethod == 2) {
        this.inputNum2(val, cell)
      } else {
        this.inputNum1(val, cell)
     }
    },
    inputNum1(val, cell) {
      // val = `${val}`.replace(/[^\d]/g, '');
      // 移除非数字和非小数点字符
      val = `${val}`.replace(/[^\d.]/g, '');
      // 确保小数点后最多两位
      var parts = val.split('.');
      if (parts.length > 1) {
          parts[1] = parts[1].substring(0, 2); // 截取小数点后两位
          val = parts.join('.');
      }
      // 确保只有一个小数点
      var decimalCount = (val.match(/\./g) || []).length;
      if (decimalCount > 1) {
        val = val.substr(0, val.lastIndexOf('.'));
      }
      // 如果小数点位于数字的最前面，添加整数部分
      if (val.startsWith('.')) {
        val = '0' + val
      }

      // 确保输入不超过100
      if (Number(val) >= 100) {
        val = 99;
      }
      if (val == '') {
        cell.value.discount = null;
      } else {
        // val = Number(val);
        // if (val > 99) {
        //   val = 99;
        // }
        cell.value.discount = val;
      }
    },
    inputNum2(val, cell) {
      // val = `${val}`.replace(/[^\d]/g, '');
      // 移除非数字和非小数点字符
      val = `${val}`.replace(/[^\d.-]/g, '');
      // 确保小数点后最多两位
      var parts = val.split('.');
      if (parts.length > 1) {
          parts[1] = parts[1].substring(0, 2); // 截取小数点后两位
          val = parts.join('.');
      }
      // 确保只有一个小数点
      var decimalCount = (val.match(/\./g) || []).length;
      if (decimalCount > 1) {
        val = val.substr(0, val.lastIndexOf('.'));
      }
      // 如果小数点位于数字的最前面，添加整数部分
      if (val.startsWith('.')) {
        val = '0' + val
      }
      if (cell.value.discountType === null || cell.value.discountType === '' || cell.value.discountType == '1' ){
        if (Number(val) < -99.99 || Number(val) >200 ) {
          val = 200;
        }
      }else{
        // 确保输入不超过100
        if (Number(val) < 0 || Number(val) >= 100) {
          val = 99;
        }
      }
      if (val == '') {
        cell.value.discount = null;
      } else {
        // val = Number(val);
        // if (val > 99) {
        //   val = 99;
        // }
        cell.value.discount = val;
      }
    },
    onChangeDesignId(val, cell) {
      cell.value = val.trim();
      this.checkTableData3();
    },
    onChangeColorCode(val, cell) {
      cell.value = val.trim();
      this.checkTableData3();
    },
    getDisabledBrandIds1(val) {
      return this.tableData1.map(item => item.brandId.value).filter(item => item != val);
    },
    checkTableData1() {
      this.tableData1.forEach(row => {
        row.error = false;
        row.errorMessage = '';
        if (row.brandId.value == 0) { // Default 校验
          let flag = false; // 为空
          this.header.forEach((headerItem) => {
            row[headerItem.value].error = false;
            if ((row[headerItem.value].value.discount == '' || row[headerItem.value].value.discount == null) && row[headerItem.value].value.discount != 0
            || row[headerItem.value].value.discountType === "0" && (parseFloat(row[headerItem.value].value.discount) < 0 || parseFloat(row[headerItem.value].value.discount) > 100)
            || row[headerItem.value].value.discountType === "" && (parseFloat(row[headerItem.value].value.discount) < -99.99 || parseFloat(row[headerItem.value].value.discount) > 200 ) ) {
              flag = true;
              row[headerItem.value].error = true;
            }
          });
          if (flag) {
            row.errorMessage = 'Default 所有折扣必填；';
            row.error = flag;
          }
        } else { // 其他品牌校验
          row.brandId.error = false;
          if (!row.brandId.value) {
            row.error = true;
            row.errorMessage = '品牌必选；';
            row.brandId.error = true;
          }
          const discountError = this.header.every((headerItem) => {
            if (
              (row[headerItem.value].value.discount == '' || row[headerItem.value].value.discount == null) && row[headerItem.value].value.discount != 0) {
              return true;
            }
            return false;
          });
          row.error = row.error || discountError;
          if (discountError) {
            row.errorMessage += '当前行的折扣至少需要设置一个折扣；';
          }
          this.header.forEach((headerItem) => {
            row[headerItem.value].error = discountError;
          });
          this.header.find((headerItem) => {
            row[headerItem.value].error = false;
            if (row[headerItem.value].value.discountType === "0" && (row[headerItem.value].value.discount === ""|| row[headerItem.value].value.discount === null || row[headerItem.value].value.discount && (parseFloat(row[headerItem.value].value.discount) < 0 || parseFloat(row[headerItem.value].value.discount) > 100))
            || row[headerItem.value].value.discountType === "" && row[headerItem.value].value.discount && (parseFloat(row[headerItem.value].value.discount) <= -100 || parseFloat(row[headerItem.value].value.discount) > 200 ) ) {
              row[headerItem.value].error = true;
              row.error = true
              row.errorMessage = '折扣设置错误';
            }
          });
        }
      });
    },
    checkTableData2() {
      const brandIdAndCategoryIdList = this.tableData2.filter(item => (item.brandId.value || item.brandId.value === 0) && item.categoryId.value).map(item => {
        return `${item.brandId.value}-${item.categoryId.value}`;
      });
      // 找出brandIdAndCategoryIdList中的重复元素
      const repeatList = brandIdAndCategoryIdList.filter((item, index) => {
        return brandIdAndCategoryIdList.indexOf(item) != index;
      });
      this.tableData2.forEach(row => {
        row.error = false;
        row.errorMessage = '';
        row.brandId.error = false;
        if (!row.brandId.value && row.brandId.value != 0) {
          row.error = true;
          row.errorMessage = '品牌必选；';
          row.brandId.error = true;
        }
        row.categoryId.error = false;
        if (!row.categoryId.value) {
          row.error = true;
          row.errorMessage += '类目必选；';
          row.categoryId.error = true;
        }
        repeatList.forEach(item => {
          const arr = item.split('-');
          if (row.brandId.value == arr[0] && row.categoryId.value == arr[1]) {
            row.error = true;
            row.errorMessage += '品牌+类目重复；';
            row.brandId.error = true;
            row.categoryId.error = true;
          }
        });
        row.discount.error = false;
        if ((row.discount.value.discount == '' || row.discount.value.discount == null) && row.discount.value.discount != 0) {
          row.error = true;
          row.errorMessage += '折扣必填；';
          row.discount.error = true;
        }
        if (row.discount.value.discountType === "0" && row.discount.value.discount && (parseFloat(row.discount.value.discount) < 0 || parseFloat(row.discount.value.discount) > 100  || row.discount.value.discount === "" || row.discount.value.discount === null )
          || row.discount.value.discountType === "" && row.discount.value.discount && row.discount.value.discount && (parseFloat(row.discount.value.discount) < -99.99 || parseFloat(row.discount.value.discount) > 200 )) {
          row.error = true;
          row.errorMessage += '折扣设置错误；';
          row.discount.error = true;
        }
      });
    },
    checkTableData4() {
      const brandIdAndCategoryIdList = this.tableData4.filter(item => (item.brandId.value || item.brandId.value === 0) && item.categoryId.value).map(item => {
        return `${item.brandId.value}-${item.categoryId.value}`;
      });
      // 找出brandIdAndCategoryIdList中的重复元素
      const repeatList = brandIdAndCategoryIdList.filter((item, index) => {
        return brandIdAndCategoryIdList.indexOf(item) != index;
      });
      this.tableData4.forEach(row => {
        row.error = false;
        row.errorMessage = '';
        row.brandId.error = false;
        if (!row.brandId.value && row.brandId.value != 0) {
          row.error = true;
          row.errorMessage = '品牌必选；';
          row.brandId.error = true;
        }
        row.categoryId.error = false;
        if (!row.categoryId.value) {
          row.error = true;
          row.errorMessage += '类目必选；';
          row.categoryId.error = true;
        }
        repeatList.forEach(item => {
          const arr = item.split('-');
          if (row.brandId.value == arr[0] && row.categoryId.value == arr[1]) {
            row.error = true;
            row.errorMessage += '品牌+类目重复；';
            row.brandId.error = true;
            row.categoryId.error = true;
          }
        });
        row.discount.error = false;
        if ((row.discount.value.discount == '' || row.discount.value.discount == null) && row.discount.value.discount != 0) {
          row.error = true;
          row.errorMessage += '折扣必填；';
          row.discount.error = true;
        }
        if (row.discount.value.discountType === "0" && row.discount.value.discount && (parseFloat(row.discount.value.discount) < 0 || parseFloat(row.discount.value.discount) > 100  || row.discount.value.discount === "" || row.discount.value.discount === null )
          || row.discount.value.discountType === "" && row.discount.value.discount && row.discount.value.discount && (parseFloat(row.discount.value.discount) < -99.99 || parseFloat(row.discount.value.discount) > 200 )) {
          row.error = true;
          row.errorMessage += '折扣设置错误；';
          row.discount.error = true;
        }
      });
    },
    checkTableData3() {
      const designerIdAndColorCodeList = this.tableData3.filter(item => item.designerId.value && item.colorCode.value).map(item => {
        return `${item.designerId.value}-${item.colorCode.value}`;
      });
      // 找出designerIdAndColorCodeList中的重复项
      const repeatList = designerIdAndColorCodeList.filter((item, index) => {
        return designerIdAndColorCodeList.indexOf(item) != index;
      });
      this.tableData3.forEach(row => {
        row.error = false;
        row.errorMessage = '';
        row.designerId.error = false;
        if (!row.designerId.value) {
          row.error = true;
          row.errorMessage = '货号必填；';
          row.designerId.error = true;
        }
        row.colorCode.error = false;
        if (!row.colorCode.value) {
          row.error = true;
          row.errorMessage += '色号必填；';
          row.colorCode.error = true;
        }
        repeatList.forEach(item => {
          const arr = item.split('-');
          if (row.designerId.value == arr[0] && row.colorCode.value == arr[1]) {
            row.error = true;
            row.errorMessage += '货号+色号重复；';
            row.designerId.error = true;
            row.colorCode.error = true;
          }
        });
        row.discount.error = false;
        if ((row.discount.value.discount == '' || row.discount.value.discount == null) && row.discount.value.discount != 0) {
          row.error = true;
          row.errorMessage += '折扣必填；';
          row.discount.error = true;
        }
        if (row.discount.value.discountType === "0" && row.discount.value.discount && (parseFloat(row.discount.value.discount) < 0 || parseFloat(row.discount.value.discount) > 100  || row.discount.value.discount === "" || row.discount.value.discount === null )
          || row.discount.value.discountType === "" && row.discount.value.discount && parseFloat(row.discount.value.discount) && (parseFloat(row.discount.value.discount) < -99.99 || parseFloat(row.discount.value.discount) > 200 )) {
          row.error = true;
          row.errorMessage += '折扣设置错误；';
          row.discount.error = true;
        }
      });
    },
    onClickRemove1(scope) {
      this.tableData1.splice(this.tableData1.findIndex(item => item.originIndex === scope.row.originIndex), 1);
      this.checkTableData1();
    },
    onClickRemove2(scope) {
      this.tableData2.splice(this.tableData2.findIndex(item => item.originIndex === scope.row.originIndex), 1);
      this.checkTableData2();
    },
    onClickRemove4(scope) {
      this.tableData4.splice(this.tableData4.findIndex(item => item.originIndex === scope.row.originIndex), 1);
      this.checkTableData4();
    },
    onClickRemove3(scope) {
      this.tableData3.splice(this.tableData3.findIndex(item => item.originIndex === scope.row.originIndex), 1);
      this.checkTableData3();
    },
    onClickAdd() {
      if (this.activeName === 'first') {
        const row = {
          brandId: {
            isEdit: false,
            value: null,
            error: true,
            oldValue: null, // 旧值
          },
          error: true,
          errorMessage: '品牌必选；当前行的折扣至少需要设置一个折扣；',
          originIndex: this.autoIncrement1++,
        };
        this.header.forEach((headerItem) => {
          row[headerItem.value] = {
            isEdit: false,
            value: {
              discount: null,
              discountType: null
            },
            error: true,
            oldValue: {
              discount: null,
              discountType: null
            }, // 旧值
          };
        });
        this.tableData1.push(row);
        this.$nextTick(() => {
          this.$refs.VirtualScrollTable1.scrollToBottom();
        })
      }
      if (this.activeName === 'second') {
        const row = {
          brandId: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          categoryId: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          discount: {
            isEdit: false,
            value: {
              discount: null,
              discountType: null
            },
            error: true, // 错误
            oldValue: {
              discount: null,
              discountType: null
            }, // 旧值
          },
          error: false,
          errorMessage: '品牌必选；类目必选；折扣必填；',
          originIndex: this.autoIncrement2++,
        };
        this.tableData2.push(row);
        this.$nextTick(() => {
          this.$refs.VirtualScrollTable2.scrollToBottom();
        })
      }
      if (this.activeName === 'fourth') {
        const row = {
          brandId: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          categoryId: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          discount: {
            isEdit: false,
            value: {
              discount: null,
              discountType: null
            },
            error: true, // 错误
            oldValue: {
              discount: null,
              discountType: null
            }, // 旧值
          },
          error: false,
          errorMessage: '品牌必选；类目必选；折扣必填；',
          originIndex: this.autoIncrement4++,
        };
        this.tableData4.push(row);
        this.$nextTick(() => {
          this.$refs.VirtualScrollTable4.scrollToBottom();
        })
      }
      if (this.activeName === 'third') {
        const row = {
          designerId: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          colorCode: {
            isEdit: false,
            value: null,
            error: true, // 错误
            oldValue: null, // 旧值
          },
          discount: {
            isEdit: false,
            value: {
              discount: null,
              discountType: null
            },
            error: true, // 错误
            oldValue: {
              discount: null,
              discountType: null
            }, // 旧值
          },
          error: true,
          errorMessage: '货号必填；色号必填；折扣必填；',
          originIndex: this.autoIncrement3++,
        };
        this.tableData3.push(row);
        this.$nextTick(() => {
          this.$refs.VirtualScrollTable3.scrollToBottom();
        })
      }
    },
    async submitPage() {
      this.checkTableData1();
      this.checkTableData2();
      this.checkTableData3();
      this.checkTableData4();
      const error1 = this.tableData1.some(item => item.error);
      const error2 = this.tableData2.some(item => item.error);
      const error4 = this.tableData4.some(item => item.error);
      const error3 = this.tableData3.some(item => item.error);
      if (error1) {
        this.$message.error('当前设置有错误，请处理后提交；请检查二级类目');
        return;
      }
      if (error2) {
        this.$message.error('当前设置有错误，请处理后提交；请检查三级类目');
        return;
      }
      if (error4) {
        this.$message.error('当前设置有错误，请处理后提交；请检查四级类目');
        return;
      }
      if (error3) {
        this.$message.error('当前设置有错误，请处理后提交；请检查特殊商品');
        return;
      }
      if (this.page === 'promotion') {
        const result = await this.$confirm('确认提交？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        if (!result) {
          return;
        }
      } else if (this.page === 'daily') {
        const checkRes = await checkPriceChangeRule(this.routeQuery.id);
        if (checkRes.data && checkRes.data.runStatus == 2) {
          this.$message('当前折扣计算中无法提交，请稍后处理');
          return;
        }
        let msg = '确认提交？';
        if (!checkRes.success) {
          this.$message.error(checkRes.message || '系统异常，请稍后再试');
          return;
        }
        if (this.routeQuery.status == '2' && checkRes.data && checkRes.data.hasPending) {
          msg = '确认提交？提交后，当前折扣立即生效，且当前待生效折扣失效（<span style="color:red">请确认是否需下载待生效折扣文件</span>)';
        }
        if (this.routeQuery.status == '2' && checkRes.data && !checkRes.data.hasPending) {
          msg = '确认提交？提交后，当前折扣立即生效';
        }
        const result = await this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning',
        });
        if (!result) {
          return;
        }
      }
      const secondCategroyDiscountList = this.tableData1.map((row) => {
        const obj = {
          brandId: row.brandId.value,
        };
        this.header.forEach((headerItem) => {
          if (row[headerItem.value].value.discount !== '' && row[headerItem.value].value.discount !== null) {
            var discountType = null;
            if (this.supplyPriceMethod === '2'){
              discountType = 1
              if (row[headerItem.value].value.discountType === '0'){
                discountType = 0
              }
            }
            obj[headerItem.value] = {...row[headerItem.value].value, discountType};
          }
        });
        return obj;
      });
      const thirdCategroyDiscountList = this.tableData2.map((row) => {
        var discountType = null;
        if (this.supplyPriceMethod === '2'){
          discountType = 1
          if (row.discount.value.discountType === '0'){
            discountType = 0
          }
        }
        return {
          brandId: row.brandId.value,
          categoryId: row.categoryId.value,
          discount: row.discount.value.discount,
          discountType: discountType,
        };
      });
      const fourthCategroyDiscountList = this.tableData4.map((row) => {
        var discountType = null;
        if (this.supplyPriceMethod === '2'){
          discountType = 1
          if (row.discount.value.discountType === '0'){
            discountType = 0
          }
        }
        return {
          brandId: row.brandId.value,
          categoryId: row.categoryId.value,
          discount: row.discount.value.discount,
          discountType: discountType,
        };
      });
      const specialProductDiscountList = this.tableData3.map((row) => {
        var discountType = null;
        if (this.supplyPriceMethod === '2'){
          discountType = 1
          if (row.discount.value.discountType === '0'){
            discountType = 0
          }
        }
        return {
          designerId: row.designerId.value,
          colorCode: row.colorCode.value,
          discount: row.discount.value.discount,
          discountType: discountType,
        };
      });
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.fullscreenLoading = true;
      if (this.page === 'daily') {
        submitBoutiqueProductDiscount({
          priceChangeRuleId: this.routeQuery.id,
          secondCategroyDiscountList,
          thirdCategroyDiscountList,
          specialProductDiscountList,
          fourthCategroyDiscountList
        }).then((res) => {
          this.fullscreenLoading = false;
          if(res.success){
          this.$message.success('提交成功');
          this.onClickPage();
          this.getTableData();
          setTimeout(() => {
            this.repeatSubmit = false;
          }, 2000);
          } else {
          this.$message.error(res.message);
          }
        }).catch((err) => {
          this.repeatSubmit = false;
          this.fullscreenLoading = false;
        })
      } else if (this.page === 'promotion') {
        submitPromotionVendorDiscountDetail(this.routeQuery.id, {
          secondCategoryRuleVoList: secondCategroyDiscountList,
          thirdCategoryRuleVoList: thirdCategroyDiscountList,
          productRuleVoList: specialProductDiscountList,
        }).then((res) => {
          this.fullscreenLoading = false;
          if(res.success){
          this.$message.success('提交成功');
          this.onClickPage();
          this.getTableData();
          setTimeout(() => {
            this.repeatSubmit = false;
          }, 2000);
          } else {
          this.$message.error(res.message);
          }

        }).catch((err) => {
          this.repeatSubmit = false;
          this.fullscreenLoading = false;
        })
      }
    },
  },
};
</script>
<style scoped lang="less">
.f14 {
  font-size: 14px;
}
.red {
  color: #F56C6C;
}
.gray {
  color: #909399;
}
.pl10 {
  padding-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.mt15 {
  margin-top: 15px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.ml20 {
  margin-left: 20px;
}
.discount-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding:10px 20px 10px 20px
}
.label {
  font-size: 12px;
}
.value {
  margin-right: 20px;
  font-size: 14px;
  font-weight: 500;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-container {
  flex: 1;
}
.item-cell {
  height: 43px;
  line-height: 43px;
  white-space: pre-wrap;

  &.changed {
    border-bottom: 1px dashed #909399;
  }
  &.error {
    border-bottom: 1px solid #F56C6C;
  }
}
.item-cell:active {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
